var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossedOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.369671,
    y: 0.831829,
    width: 21.3966,
    height: 21.3966,
    rx: 3.30054,
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.227624
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8219 12.3195V6.78784H11.6922V12.3195H10.8219ZM11.257 16.6515C10.5786 16.6515 9.9404 16.5227 9.34233 16.265C8.74426 16.0073 8.22132 15.6555 7.77351 15.2097C7.32571 14.764 6.97237 14.2434 6.71351 13.648C6.45463 13.0526 6.3252 12.4173 6.3252 11.7419C6.3252 11.0125 6.47918 10.3236 6.78715 9.67531C7.09511 9.02698 7.52432 8.46734 8.07477 7.99637L8.68065 8.59952C8.21275 8.98088 7.84826 9.44592 7.58716 9.99465C7.32606 10.5434 7.19551 11.1258 7.19551 11.7419C7.19551 12.8586 7.59199 13.8117 8.38496 14.6011C9.17792 15.3904 10.1353 15.7851 11.257 15.7851C12.3885 15.7851 13.3482 15.3904 14.1364 14.6011C14.9245 13.8117 15.3186 12.8586 15.3186 11.7419C15.3186 11.1258 15.1904 10.5434 14.9342 9.99465C14.6779 9.44592 14.311 8.98088 13.8334 8.59952L14.4393 7.99637C14.9935 8.46734 15.4236 9.02698 15.7297 9.67531C16.0358 10.3236 16.1889 11.0125 16.1889 11.7419C16.1889 12.4173 16.0595 13.0526 15.8006 13.648C15.5417 14.2434 15.1899 14.764 14.745 15.2097C14.3002 15.6555 13.7788 16.0073 13.1807 16.265C12.5826 16.5227 11.9414 16.6515 11.257 16.6515Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L18.9337 18.9337",
    stroke: "#E80000",
    strokeWidth: 0.910495,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossedOn);
export default __webpack_public_path__ + "static/media/crossedON.ff92743d614656c7eec68a2f13fd6028.svg";
export { ForwardRef as ReactComponent };